import React from 'react';

import { Route, Redirect } from 'react-router-dom';


// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
//import ContentPaste from "@material-ui/icons/ContentPaste";
import DeveloperBoard from "@material-ui/icons/DeveloperBoard";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CustomersIcon, ProductsIcon, ProfileIcon, ServicesIcon, UsersIcon, EmailsIcon, ReportsIcon, MonitorIcon, SignOutIcon, LicenseIcon } from "../variables/dataIcons.jsx";
import AddCustomer from "../views/Customers/AddCustomer.jsx";
import AddProducts from '../views/Products/AddProducts.jsx';
import SearchCustomers from '../views/Customers/SearchCustomers.jsx';
import ViewCustomer from '../views/Customers/ViewCustomer.jsx';
import ViewProfile from '../views/Users/ViewProfile.jsx';
import ComposeEmail from '../views/Emails/ComposeEmail.jsx';
import ManageEmails from '../views/Emails/ManageEmails.jsx';
import RoleCheckDashboard from '../views/Dashboard/RoleCheckDashboard.jsx';
import Api from '../api/Api.js';
import SearchProducts from '../views/Products/SearchProducts.jsx';
import SearchReports from '../views/Reports/SearchReports.jsx';
import SearchUsers from '../views/Users/SearchUsers.jsx';
import SearchServices from '../views/Services/SearchServices.jsx';
import AddOrEditReport from '../views/Reports/AddOrEditReport.jsx';
import { AvailableRoles } from './PrivateRoute.jsx';
import ViewProduct from '../views/Products/ViewProduct.jsx';
import ForceRerenderWrapper from '../components/Wrapper/ForceRerenderWrapper.jsx';
import AddUser from '../views/Users/AddUser.jsx';
import RecentHistory from '../views/Reports/History/RecentHistory.jsx';
import ArchiveHistory from '../views/Reports/History/ArchiveHistory.jsx';
import ReportHistory from '../views/Reports/History/ReportHistory.jsx';
import ViewReport from '../views/Reports/ViewReport.jsx';
import FtpMain from '../views/Reports/FtpMain.jsx';
import FtpReports from '../views/Reports/FtpReports.jsx';
import FtpEdit from '../views/Reports/FtpEdit.jsx';
import FtpAdd from '../views/Reports/FtpAdd.jsx';
import AddService from '../views/Services/AddService.jsx';
import ViewService from '../views/Services/ViewService.jsx';
import DeveloperDashboard from '../views/Dashboard/DeveloperDashboard.jsx';
import AddLicense from '../views/Licenses/AddLicense.jsx';
import NotImplemented from '../views/Misc/NotImplemented.jsx';
import { faPlus, faSearch, faExchange, faHistory, faNewspaper, faEdit, faBullhorn, faMailBulk, faInboxOut, faServer, faGlobe } from '@fortawesome/pro-solid-svg-icons';
import NotifyCustomerEmail from '../views/Emails/NotifyCustomerEmail.jsx';
import ViewLicense from '../views/Licenses/ViewLicense.jsx';
import ManageLicenses from '../views/Licenses/ManageLicenses.jsx';
import SystemDetector from '../views/Systems/SystemDetector.jsx';
import Grafana from '../views/Monitoring/Grafana.jsx';
import { ReactComponent as GrafanaLogo } from '../assets/img/grafana.svg';
import { faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import WebChanges from '../views/Monitoring/WebChanges.jsx';
import GooglePlay from '../views/Monitoring/GooglePlay.jsx';


export const NotClient = AvailableRoles.filter(x => x !== 'Client');
export const OpsOrAbove = [
  "Admin",
  "OpsManager",
  "Ops"
];

var customers = [
  {
    path: "/customers/add",
    name: "Add Customer",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faPlus} />,
    component: AddCustomer
  },
  {
    path: "/customers/search",
    name: "Search Customer",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faSearch} />,
    component: SearchCustomers
  },
  {
    path: "/:c(customers|customer)/view/:id/:tab?/:tab_id?",
    name: "View Customer",
    component: (props) => <ForceRerenderWrapper match={props.match} refreshParam="id"><ViewCustomer {...props} /></ForceRerenderWrapper>,
    redirect: true
  }
]

var products = [
  {
    path: "/products/add",
    name: "Add Products",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faPlus} />,
    component: AddProducts
  },
  {
    path: "/products/search",
    name: "Search Products",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faSearch} />,
    component: SearchProducts
  },
  {
    path: "/:p(products|product)/view/:product_id/:customer_id?",
    name: "View Products",
    component: (props) => <ForceRerenderWrapper match={props.match} refreshParam="product_id"><ViewProduct {...props} /></ForceRerenderWrapper>,
    redirect: true
  }
]

var reports = [
  {
    path: "/reports/add",
    name: "Add Reports",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faPlus} />,
    component: AddOrEditReport,
    roles: ["Admin"]
  },
  {
    path: "/reports/search",
    name: "Search Reports",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faSearch} />,
    component: SearchReports
  },
  {
    path: "/reports/recentHistory",
    name: "Recent Reports",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faNewspaper} />,
    component: RecentHistory
  },
  {
    path: "/reports/archived",
    name: "Archived Reports",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faHistory} />,
    component: ArchiveHistory
  },
  {
    path: "/reports/ftp",
    name: "Remote Servers",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faExchange} />,
    component: FtpMain,
    roles: ['Admin']
  },
  {
    path: "/:r(reports|report)/ftpReports/:id",
    name: "Server Reports",
    component: FtpReports,
    redirect: true,
    roles: ['Admin']
  },
  {
    path: "/:r(reports|report)/ftpEdit/:id",
    name: "Edit FTP Report",
    component: FtpEdit,
    redirect: true,
    roles: ['Admin']
  },
  {
    path: "/:r(reports|report)/ftpAdd",
    name: "Add FTP Report",
    component: FtpAdd,
    redirect: true,
    roles: ['Admin']
  },
  {
    path: "/:r(reports|report)/history/:id",
    name: "History for Report",
    component: ReportHistory,
    redirect: true
  },
  {
    path: "/:r(reports|report)/view/:id",
    name: "View Report",
    component: ViewReport,
    redirect: true
  },
  {
    path: "/:r(reports|report)/:mode(edit|copy)/:id",
    name: "Edit Reports",
    component: (props) => <ForceRerenderWrapper match={props.match} refreshParam="id"><AddOrEditReport {...props} /></ForceRerenderWrapper>,
    roles: ["Admin"],
    redirect: true
  },
]

var emails = [
  {
    path: "/emails/compose",
    name: "Compose Email",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faEdit} />,
    component: ComposeEmail
  },
  {
    path: "/emails/outbox",
    name: <span>Outbox&nbsp;&nbsp;<small>(coming soon)*</small></span>,
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faInboxOut} />,
    component: NotImplemented
  },
  {
    path: "/emails/notifyCustomer",
    name: "Notify Customer",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faBullhorn} />,
    component: NotifyCustomerEmail
  },
  {
    path: "/emails/manage",
    name: "Manage Emails",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faMailBulk} />,
    component: ManageEmails
  },
]

var users = [
  {
    path: "/users/add",
    name: "Add User",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faPlus} />,
    component: AddUser
  },
  {
    path: "/users/search",
    name: "Search User",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faSearch} />,
    component: SearchUsers
  },
  {
    path: "/:u(users|user)/view/:user_id",
    name: "View User",
    component: ViewProfile,
    redirect: true,
    //preload: () => allUsers(),
  }
]

var services = [
  {
    path: "/services/add",
    name: "Add Services",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faPlus} />,
    component: AddService
  },
  {
    path: "/services/search",
    name: "Search Services",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faSearch} />,
    component: SearchServices
  },
  {
    path: "/:s(services|service)/view/:service_id",
    name: "View Service",
    component: ViewService,
    redirect: true,
    //preload: () => allServices(),
  }
]

var licenses = [
  {
    path: "/license/add",
    name: "Add Licenses",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faPlus} />,
    component: AddLicense
  },
  {
    path: "/license/search",
    name: "Search Licenses",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faSearch} />,
    component: ManageLicenses
  },
  {
    path: "/:l(license|licenses)/view/:license_id",
    name: "View License",
    component: ViewLicense,
    redirect: true,
    //preload: () => allServices(),
  }
]

var systems = [
  {
    path: "/systems/mobiserv",
    name: "MobiServ",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faServer} />,
    component: SystemDetector,
  }
];

var monitoring = [
  {
    path: "/monitor/googlePlay", //https://play.google.com/store/apps/details?id=com.cellfind.fedchat
    name: "Google Play",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faGooglePlay} />,
    component: GooglePlay,
  },
  {
    path: "/monitor/web_change",
    name: "Web Change Monitor",
    mini: <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={faGlobe} />,
    component: WebChanges,
  },
  {
    path: "/monitor/grafana",
    name: "Grafana",
    mini: <span style={{ marginLeft: 4 }}><GrafanaLogo /></span>,
    component: Grafana,
  }
];

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: RoleCheckDashboard
  },
  {
    path: "/devdashboard",
    name: "Developer Dashboard",
    state: "openDev",
    //views: dev,
    icon: DeveloperBoard,
    component: DeveloperDashboard,
    roles: ["Admin"]
  },
  {
    collapse: true,
    path: "/customers",
    name: "Customers",
    state: "openCustomers",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#00c0ef' }} icon={CustomersIcon} />,
    views: customers,
    roles: NotClient
  },
  {
    collapse: true,
    path: "/products",
    name: "Products",
    state: "openProducts",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#D81B60' }} icon={ProductsIcon} />,
    views: products,
    roles: NotClient
  },
  {
    collapse: true,
    path: "/reports",
    name: "Reports",
    state: "openReports",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#00a65a' }} icon={ReportsIcon} />,
    views: reports
  },
  {
    collapse: true,
    path: "/email",
    name: "Emails",
    state: "openEmails",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#007bff' }} icon={EmailsIcon} />,
    views: emails,
    roles: NotClient
  },
  {
    collapse: true,
    path: "/user",
    name: "Users",
    state: "openUsers",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#605ca8' }} icon={UsersIcon} />,
    views: users,
    roles: NotClient
  },
  {
    collapse: true,
    path: "/services",
    name: "Services",
    state: "openServices",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#00a65a' }} icon={ServicesIcon} />,
    views: services,
    roles: NotClient
  },
  {
    collapse: true,
    path: "/license",
    name: "Licenses",
    state: "openLicenses",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: 'goldenrod' }} icon={LicenseIcon} />,
    views: licenses,
    roles: NotClient
  },
  {
    collapse: true,
    path: "/systems",
    name: "Systems",
    state: "openSystems",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#d81b40' }} icon={faServer} />,
    views: systems,
    roles: OpsOrAbove
  },
  {
    path: "/profile",
    name: "Profile",
    state: "openProfile",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#39CCCC' }} icon={ProfileIcon} />,
    component: ViewProfile,
    roles: NotClient
  },
  {
    collapse: true,
    path: "/monitor",
    name: "Monitoring",
    state: "openMonitoring",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: '#d81b40' }} icon={MonitorIcon} />,
    views: monitoring,
    roles: NotClient
  },
  {
    path: "/logout",
    name: "Sign out",
    state: "openLogout",
    icon: () => <FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4 }} icon={SignOutIcon} />,
    component: () => {
      Api.signout();
      return <Route render={() => <Redirect to="/lockedOut" />} />
    }
  },
  { redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard" }
];
export default dashRoutes;
